function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { computed, defineComponent, onBeforeUnmount, onMounted, ref, getCurrentInstance } from "vue";
import { definePropType } from "@types-vue/props";
import { FileStatus, UploadStatus } from "@pt/store/assets/uploader.type";
import EditShowTitle from "@pt/components/edit-show-title.vue";
import ProgressBar from "@com/components/progress-bar/index.vue";
import { getFileExtension, getFileName, isValidFileName } from "@com/utils/file";
import useUploaderModule from "@pt/views/pt-entry/creative-assets/media/uploader-module";
import { getTypesByExtension } from "@pt/views/pt-entry/creative-assets/media/config";
import { utilsIcon } from "./config";
import i18n from "@/lang";
export default defineComponent({
    components: {
        EditShowTitle: EditShowTitle,
        ProgressBar: ProgressBar
    },
    props: {
        file: {
            type: definePropType(Object),
            required: true
        }
    },
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var isUploadingStatus = useUploaderModule().isUploadingStatus;
        var icon = computed(function() {
            return utilsIcon[getTypesByExtension(props.file.getExtension())] || "";
        });
        var fileExtraPro = computed(function() {
            return store.state.assets.uploader.fileExtraList.find(function(item) {
                return item.id === props.file.id;
            });
        });
        var editable = computed(function() {
            return !isUploadingStatus.value;
        });
        var checked = computed({
            get: function() {
                return fileExtraPro.value.selected;
            },
            set: function(val) {
                if (val) {
                    store.commit("assets/uploader/selectFile", props.file.id);
                } else {
                    store.commit("assets/uploader/unSelectFile", props.file.id);
                }
            }
        });
        var isSuccessStatus = computed(function() {
            return [
                FileStatus.uploadSuccess,
                FileStatus.onlineCheckSuccess
            ].includes(fileExtraPro.value.status);
        });
        var isErrorStatus = computed(function() {
            return [
                FileStatus.uploadError,
                FileStatus.offlineCheckFail,
                FileStatus.onlineCheckFail,
                FileStatus.Error, 
            ].includes(fileExtraPro.value.status);
        });
        var isEditDisabled = computed(function() {
            return fileExtraPro.value.status === FileStatus.Error;
        });
        var fileItemDisabled = computed(function() {
            return isErrorStatus.value || !fileExtraPro.value.md5;
        });
        var isFileUploadingStatus = computed(function() {
            return fileExtraPro.value.status === FileStatus.uploading;
        });
        var isFileUploadError = computed(function() {
            return FileStatus.uploadError === fileExtraPro.value.status;
        });
        var detailMessage = computed(function() {
            if (isFileUploadingStatus.value) {
                if (fileExtraPro.value.progress === 95) {
                    return i18n.t("playTurbo.assetLibrary.asset.creating");
                }
                return i18n.t("playTurbo.assetLibrary.asset.uploading");
            } else if (FileStatus.uploadSuccess === fileExtraPro.value.status) {
                return i18n.t("playTurbo.assetLibrary.asset.upload.completed");
            } else if (isFileUploadError.value) {
                return i18n.t("playTurbo.assetLibrary.asset.upload.failed");
            }
            return fileExtraPro.value.errorMsg;
        });
        var innerName = computed(function() {
            return props.file.name;
        });
        var handleRetry = function() {
            props.file.retry();
            store.commit("assets/uploader/setUploadStatus", UploadStatus.uploading);
            store.commit("assets/uploader/updateFileExtraProp", {
                id: props.file.id,
                data: {
                    status: FileStatus.uploading,
                    progress: 0
                }
            });
        };
        var handleCancel = function() {
            store.commit("assets/uploader/removeFile", props.file);
            props.file.cancel();
        };
        var changeName = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(val) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            // eslint-disable-next-line vue/no-mutating-props
                            props.file.name = val;
                            fileExtraPro.value.name = val;
                            store.commit("assets/uploader/resetFileStatus", props.file.id);
                            store.commit("assets/uploader/checkIsSameName");
                            _ctx.next = 6;
                            return store.dispatch("assets/uploader/checkAssetsIsValid", props.file.id);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function changeName(val) {
                return _ref.apply(this, arguments);
            };
        }();
        onMounted(function() {});
        onBeforeUnmount(function() {});
        var hoverStatus = ref(false);
        var suffix = "";
        var beforeName = "";
        // 确保修改文案的时候，先过滤资源后缀
        var beforeAfterProcess = function(type, content) {
            if (type === "before") {
                hoverStatus.value = true;
                suffix = getFileExtension(content);
                beforeName = getFileName(content, true);
                return beforeName;
            } else if (type === "after") {
                hoverStatus.value = false;
                if (!isValidFileName(content)) {
                    root.$message.error('\u6587\u4EF6\u540D\u4E0D\u5141\u8BB8\u4E3A\u7A7A\uFF0C\u5E76\u4E14\u4E0D\u5141\u8BB8\u4F7F\u7528<>/|:"*?\u7B49\u5B57\u7B26\uFF0C\u5E76\u4E14\u957F\u5EA6\u4E0D\u5141\u8BB8\u8D85\u8FC7 200');
                    return beforeName + "." + suffix;
                }
                return content + "." + suffix;
            }
        };
        return {
            checked: checked,
            innerName: innerName,
            changeName: changeName,
            progressBarAttrs: {
                size: "small",
                bgColor: "#ddd",
                barColor: "#F3C547",
                barBorderRadius: 6
            },
            inputProp: {
                size: "mini",
                maxlength: 200,
                showWordLimit: true
            },
            beforeAfterProcess: beforeAfterProcess,
            fileExtraPro: fileExtraPro,
            isSuccessStatus: isSuccessStatus,
            isErrorStatus: isErrorStatus,
            isEditDisabled: isEditDisabled,
            isFileUploadingStatus: isFileUploadingStatus,
            detailMessage: detailMessage,
            editable: editable,
            handleRetry: handleRetry,
            isFileUploadError: isFileUploadError,
            handleCancel: handleCancel,
            icon: icon,
            hoverStatus: hoverStatus,
            fileItemDisabled: fileItemDisabled
        };
    }
});
